import { Component, inject, effect } from '@angular/core';
import { Router } from '@angular/router';

import { ImageCaptureStepComponent } from './components/image-capture-step/image-capture-step.component';
import { ImageReviewStepComponent } from './components/image-review-step/image-review-step.component';
import { IdVerificationStore } from '../../store/id-verification-store';
import { FaceDetectionStore } from '../../store/face-detection.store';

@Component({
  selector: 'app-id-verification',
  templateUrl: './id-verification.component.html',
  styleUrls: ['./id-verification.component.scss'],
  imports: [ImageCaptureStepComponent, ImageReviewStepComponent],
  providers: [IdVerificationStore, FaceDetectionStore],
})
export class IdVerificationComponent {
  private readonly router = inject(Router);
  private readonly idVerificationStore = inject(IdVerificationStore);

  isImageCaptured = this.idVerificationStore.isImageCaptured;

  constructor() {
    effect(() => {
      if (this.idVerificationStore.isFlowComplete()) {
        this.router.navigate(['/signature-and-initials'], {
          queryParamsHandling: 'preserve',
        });
      }
    });
  }
}
